import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';


const PrivateRoute = () => {
    const { token } = useAuth();
    console.log(token)

    return token ? <Outlet /> : <Navigate to="/employee/login" />;
};

export default PrivateRoute;